import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { activateCards } from '../api/simActionsApi';

export const useActivateMutation = (
  options?: Omit<UseMutationOptions<void, Error, { iccids: string[] }, unknown>, 'mutationFn'>,
) => {
  return useMutation({
    ...options,
    mutationFn: (props: { iccids: string[] }) => {
      return activateCards(props);
    },
  });
};
